import React, { createContext, useState, useEffect } from 'react';
import config from '../config';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const checkAuth = () => {
    const sessionToken = sessionStorage.getItem(config.TOKEN);
    const localToken = localStorage.getItem(config.TOKEN);
    return (sessionToken !== null && sessionToken !== undefined) || 
           (localToken !== null && localToken !== undefined) ||
           config.IS_DEV;
  };

  const [isAuthenticated, setIsAuthenticated] = useState(checkAuth());

  useEffect(() => {
    const handleAuthChange = (event) => {
      const { isAuthenticated: newAuthState } = event.detail;
      setIsAuthenticated(newAuthState);
    };

    window.addEventListener('authStateChanged', handleAuthChange);
    return () => window.removeEventListener('authStateChanged', handleAuthChange);
  }, []);

  const login = (token, stayLoggedIn = false) => {
    if (stayLoggedIn) {
      localStorage.setItem(config.TOKEN, token);
      sessionStorage.removeItem(config.TOKEN);
    } else {
      sessionStorage.setItem(config.TOKEN, token);
      localStorage.removeItem(config.TOKEN);
    }
    setIsAuthenticated(true);
  };

  const logout = () => {
    sessionStorage.removeItem(config.TOKEN);
    localStorage.removeItem(config.TOKEN);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuth: isAuthenticated, login, logout }} data-auth-context>
      {children}
    </AuthContext.Provider>
  );
};
